import Chip from '@mui/material/Chip';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import DashboardCard, { EmptyState } from './DashboardCard';
import { fmtInt } from './formatters';

const SIGNALS = {
  frequentRefresh: { label: 'Frequent refresh', sx: { bgcolor: '#FFF3E0', color: '#9A3412' } },
  manyIps: { label: 'Many IP addresses', sx: { bgcolor: '#E3EAF7', color: '#1E3A8A' } },
};

/** Licenses with unusually many refreshes or distinct IP addresses in the range (thresholds live in dashboard.php). */
export default function WatchListTable({ rows = [], sx }) {
  return (
    <DashboardCard
      title="Watch list: unusual license activity"
      subtitle="Licenses with the most re-activations or the most distinct IP addresses in the period"
      flush
      sx={sx}
    >
      {rows.length === 0 ? (
        <EmptyState>Nothing unusual in this range</EmptyState>
      ) : (
        <TableContainer>
          <Table size="small" sx={{ minWidth: 760, '& td, & th': { py: 1.25 }, '& tr > :first-of-type': { pl: 3 }, '& tr > :last-child': { pr: 3 } }}>
            <TableHead>
              <TableRow>
                <TableCell>License</TableCell>
                <TableCell>Customer</TableCell>
                <TableCell>Product</TableCell>
                <TableCell align="right">Activations</TableCell>
                <TableCell align="right">Refreshes</TableCell>
                <TableCell align="right">Distinct IPs</TableCell>
                <TableCell>Signal</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r) => {
                const signal = SIGNALS[r.signal] ?? { label: r.signal, sx: {} };
                return (
                  <TableRow key={r.licenseId} hover>
                    <TableCell sx={{ fontFamily: 'monospace' }}>{r.licenseId}</TableCell>
                    <TableCell>{r.company}</TableCell>
                    <TableCell>{r.product}</TableCell>
                    <TableCell align="right">{fmtInt(r.activations)}</TableCell>
                    <TableCell align="right">{fmtInt(r.refreshes)}</TableCell>
                    <TableCell align="right">{fmtInt(r.distinctIps)}</TableCell>
                    <TableCell><Chip size="small" label={signal.label} sx={signal.sx} /></TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </DashboardCard>
  );
}
